module.exports = __webpack_public_path__ + "img/cx_img1.6b60f3f9.png";